// extracted by mini-css-extract-plugin
export const status = "S_cb";
export const publishing = "S_cc";
export const banned = "S_cd";
export const paused = "S_cf";
export const scheduling = "S_cg";